module.exports = __webpack_public_path__ + "assets/846c016aa9fe688df7ac521f5687cc8f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/12/Drop_Scatter2.mp3
 ** module id = 212
 ** module chunks = 0
 **/